export const CLAUDE_CONNECTOR_HELP_URL =
  "https://help.runplutus.com/en/articles/17567965-connect-plutus-to-claude?utm_source=email&utm_medium=email&utm_campaign=claude_connector&utm_content=help_article";
